module.exports = __webpack_public_path__ + "images/0b3e78af8c1a8db1564637f95807bf67.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/camc_logo.png
// module id = 1308
// module chunks = 0